import type { FieldValues, Path, UseFormReturn } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { Input, type InputProps } from '@/components/ui/input';

export const InputController = <T extends FieldValues>({
  name,
  methods,
  ...inputProps
}: InputProps & {
  name: Path<T>;
  methods: UseFormReturn<T>;
}) => {
  return (
    <Controller
      {...methods}
      name={name}
      render={({ field }) => <Input {...inputProps} {...field} />}
    />
  );
};
